export const baseFontFamily = 'DM Sans';
export const baseFontSize = '18px';



export const fontWeight = {
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
};

export const fontSize = {
  b1: '14px',
  b2: '12px',
  b3: '10px',
  h5: '16px',
  h4: '20px',
  h3: '24px',
  h2: '28px',
  h1: '32px',
};

export const fontSizeMobile = {
  b1: '14px',
  b2: '12px',
  b3: '10px',
  h5: '16px',
  h4: '18px',
  h3: '20px',
  h2: '22px',
  h1: '24px',
}